import permissions from 'constants/permissions'

const DOCUMENT_TEMPLATE_LIST = [
  {
    name: 'Listar',
    tag: permissions.ADVISOR_DOCUMENT_TEMPLATE.VIEW,
  },
  {
    name: 'Gerenciar',
    tag: permissions.ADVISOR_DOCUMENT_TEMPLATE.MANAGE,
  },
]

export default DOCUMENT_TEMPLATE_LIST
